import { IAvatarAssetImage } from './IAvatarAssetImage';
import { IAvatarAssetImageSize } from './IAvatarAssetImageSize';

export interface IAvatarAssetColorsMapPermanentImageItem {
    srcColor: string;
    image: IAvatarAssetImage;
    size: IAvatarAssetImageSize;
}
